import React from "react";
import mainImg from "../images/main-img.svg";
import blob from "../images/blob.svg";
import Button from "./Button";
import { navigate } from "gatsby";

function Hero() {

  return (
    <div className="overflow-x-hidden">
      <img className="object-contain hidden xl:inline opacity-75 z-10 absolute top-0 left-0 h-64 transform translate-y-full" src={blob} alt="left-blob-img" />
      <img className="object-contain hidden xl:inline opacity-75 z-10 absolute bottom-0 right-0 h-64 rotate-90 transform -translate-y-full" src={blob} alt="right-blob-img" />
      <img className="object-contain hidden xl:inline opacity-75 z-10 absolute inset-x-0 top-0 mx-auto h-64 transform -translate-y-1/2" src={blob} alt="top-blob-img" />
      <main className="mx-auto mt-10 px-6 pb-12">        
        <div className="text-center w-4/5 sm:w-2/3 mx-auto py-4" data-aos="fade-in">
          <h2 className="text-3xl leading-tight font-extrabold text-gray-900 xs:text-4xl sm:text-5xl md:text-6xl">
            Build landing pages <br /><span className="text-indigo-600">that convert</span>
          </h2>
          <p className="mt-6 text-base font-body text-gray-700 sm:text-lg sm:text-xl md:text-2xl">
            Get premium quality React + TailwindCSS landing page templates to increase leads and sales from your website.
          </p>
          <div className="mt-5 sm:mt-8 sm:flex sm:justify-center">
            <Button
              btnText="Get Templates"
              color="dark"
              onClick={() => navigate("/templates")}
            />
          </div>
        </div>
        <div className="hero-image container mx-auto mt-6 lg:mt-12" data-aos="fade-up">          
          <img className="w-full mx-auto z-20 object-contain md:max-w-xl lg:max-w-4xl" src={mainImg} alt="main-img" />
        </div>
      </main>
    </div>
  );
}

export default Hero;